import React from "react"
import MapsTab from "@/features/dashboard/components/maps-tab"

interface PlanningMapTabProps {
    homeId?: string
}

function PlanningMapTab({ homeId }: PlanningMapTabProps) {
    return <MapsTab homeId={homeId} />
}

export default PlanningMapTab
